import { ResolveFn } from '@angular/router';
import { DeploymentsService } from '../services/deployments.service';
import { DeploymentSummaries } from '../models/deployment';
import { inject } from '@angular/core';

export const deploymentListResolver: ResolveFn<DeploymentSummaries> = () => {

    return inject(DeploymentsService).getDeployments();
};
